<template>
	<div id="tabbed-container" v-bind:class="`tab-${content[which][tabType].classes}`">
		<div id="tabbed-contents">
			<div id="tc-hdr">
				<h3>
					<span>{{content[which][tabType].title}}</span><sup>{{content[which][tabType].sup}}</sup>
				</h3>
			</div>
			<div id="tc-nav">
				<nav>
					<ul>
						<li v-for="(tab,tabKey,index) in content[which][tabType].tabs" 
							v-bind:key="tabKey"  
							v-bind:class="index === activeTab ? 'active': ''"
							v-on:click="changeTab(index)"
						>
							<span v-html="tab.name"></span>
						</li>
					</ul>
				</nav>
			</div>
			<div id="tc-main">
				<div id="all-tabs">
					<div v-for="(tabContent,tabKey,idx) in content[which][tabType].tabs" 
							v-bind:key="tabKey" 
							class="tab-content"
							v-bind:class="idx === activeTab ? 'active': ''"
					>
						<img v-if="tabContent.img" v-bind:width="tabContent.img" 
						v-bind:src="require(`@/assets/patients/${which}/${tabType}/content-${idx}.png`)" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		which: {
			type: String
		},
		tabType: {
			type: String
		}
	},
	data() {
		return {
			activeTab: 0,
			content: {
				carson: {
					"cycle-1": {
						classes: null,
						title: "NEUTROPENIA DATA IN VENETOCLAX CLINICAL TRIALS",
						sup: 1,
						tabs: {
							tab0: {
								name: "VIALE-A<br> Overview",
								img: 879
							},
							tab1: {
								name: "M14-358<br> Overview",
								img: 879
							},
							tab2: {
								name: "Dose Modifications<br> in VIALE-A<sup>5</sup>",
								img: 879
							},
							tab3: {
								name: "Dose Modifications<br> in M14-358",
								img: 879
							}
						}
					}
				},
				gordon: {
					"cycle-3": {
						classes: null,
						title: "NEUTROPENIA DATA IN VENETOCLAX CLINICAL TRIALS",
						tabs: {
							tab0: {
								name: 'Neutropenia and<br>Infection in MURANO<sup>2-5</sup>',
								img: 879
							},
							tab1: {
								name: 'Dose Modification due to<br>Neutropenia in MURANO<sup>2,5</sup>',
								img: 879
							},
							tab2: {
								name: 'Neutropenia and <br>Infection in CLL14<sup>1,5,6</sup>',
								img: 879
							},
							tab3: {
								name: 'Dose Modification due to <br>Neutropenia in CLL14<sup>1</sup>',
								img: 879
							}
						}
					},
					"cycle-4": {
						classes: 'cycle-4-gordon',
						title: "SUPPORTING INFORMATION",
						tabs: {
							tab0: {
								name: 'Venetoclax Prescribing Information (Section 2.5)<sup>1</sup>',
								img: 879
							},
							tab1: {
								name: 'Neutropenia in CLL14<sup>5,6</sup>',
								img: 879
							}
						}
					}
				}
			}
		}
	},
	methods: {
		changeTab(index){
			this.activeTab = index
		}
	},
}
</script>
<style scoped>
#tabbed-container {
	font-family: Arial, Helvetica, sans-serif;
	/* display: grid;
	place-items: center;
	width: 100%;
	height: 100%; */
	min-height: 686px;
}

	#tabbed-container.tab-cycle-4-gordon {
		background-color: #fff;
		border-bottom-right-radius: 9px;
		border-bottom-left-radius: 9px;
		min-height: 30px;
	}

	#tabbed-contents {
		background-color: rgba(255,255,255,1);
		border-radius: 9px;
		width: 946px;
		min-height: 130px;
		padding: 34px;
	}

		.tab-cycle-4-gordon #tabbed-contents {
			background-color: transparent;
			margin-top: 109px;
		}

			.tab-cycle-4-gordon #tc-hdr {
				height: auto;
			}

	#tc-hdr {
		height: 60px;
	}

			h3 span,
			h3 sup {
				color: rgba(26,201,168);
			}

			h3 span {
				font-size: 2.1rem;
				letter-spacing: 1px;
				line-height: 1.3;
			}

			h3 sup {
				display: inline-block;
				font-size: 1.2rem;
				vertical-align: top;
				line-height: 1.3;
				padding-top: 1px;
				padding-left: 1px;
			}


nav {
	margin: 15px 0 30px;
}

	nav ul,
	nav li {
		align-items: center;
		border-radius: 30px;
		display: flex;
		justify-content: center;
		min-height: 52px;
	}

	nav ul {
		background-color: #ebedf0;
	}

		nav ul li {
			color: #201545;
			cursor: pointer;
			flex-grow: 1;
			font-size: 1.6rem;
			letter-spacing: 0.05rem;
			text-align: center;
			transition: all 180ms ease-in-out;
		}

			nav ul li.active {
				background-color: #24b6a2;
				color: #fff;
			}

.tab-content {
	display: none;
}

.tab-content.active {
	display: block;
}

#all-tabs img {
	display: block;
	margin: 0 auto;
}
</style>